module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-select"
  }, [_c('div', {
    staticClass: "seekLine"
  }, [_c('el-select', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "size": "small",
      "remote-method": _vm.adsSeek,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.selectId),
      callback: function($$v) {
        _vm.selectId = $$v
      },
      expression: "selectId"
    }
  }, _vm._l((_vm.adsArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_c('div', {
      staticClass: "opLine"
    }, [_c('div', {
      staticClass: "mText"
    }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "subText"
    }, [_c('span', [_vm._v(_vm._s(item.address))])])])])
  })), _vm._v(" "), (_vm.selectType != 1) ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "80px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addressSet('add')
      }
    }
  }, [_vm._v("添加")]) : _vm._e()], 1), _vm._v(" "), (_vm.selectType != 1) ? _c('div', {
    staticStyle: {
      "margin-top": "18px"
    }
  }, _vm._l((_vm.selectedList), function(item) {
    return _c('div', {
      staticClass: "dLine"
    }, [_c('div', {
      staticClass: "iName"
    }, [_c('span', {
      staticClass: "mText"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "sText"
    }, [_vm._v("（" + _vm._s(item.address) + "）")]), _vm._v(" "), _c('span', {
      staticClass: "dbtn",
      on: {
        "click": function($event) {
          _vm.addressSet('remove', item.name)
        }
      }
    }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
      staticClass: "iText"
    })])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-9b51cc1c"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/inCComps/adsSelect.vue
// module id = 1547
// module chunks = 1